var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.5 14.071l7.778-7.778c.39-.39 1.024-.39 1.414 0 .39.39.39 1.024 0 1.414l-6.364 6.364 6.364 6.364c.39.39.39 1.024 0 1.414-.39.39-1.023.39-1.414 0L8.5 14.071z"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyOCIgaGVpZ2h0PSIyOCIgdmlld0JveD0iMCAwIDI4IDI4Ij4KICAgIDxwYXRoIGZpbGw9ImN1cnJlbnRDb2xvciIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNOC41IDE0LjA3MWw3Ljc3OC03Ljc3OGMuMzktLjM5IDEuMDI0LS4zOSAxLjQxNCAwIC4zOS4zOS4zOSAxLjAyNCAwIDEuNDE0bC02LjM2NCA2LjM2NCA2LjM2NCA2LjM2NGMuMzkuMzkuMzkgMS4wMjQgMCAxLjQxNC0uMzkuMzktMS4wMjMuMzktMS40MTQgMEw4LjUgMTQuMDcxeiIvPgo8L3N2Zz4K";
export { SvgIconArrowLeft as ReactComponent };